import React, { lazy, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MobileFooter from "../../FooterMobileScreen";
import Style from "./Loginlayout.module.scss";
import { useDimensions } from "../../../logic/Dimensions";
import { useLocation } from "react-router-dom";
import {
  fetch_clientDetails,
  getCountryData,
} from "../../../actions/MicrositeAction";
const Header = React.lazy(() => import("../../Header"));
const Footer = React.lazy(() => import("../../Footer"));

function LoginLayout({ children, bookingProgress,mrnValidationFailed }) {
  const { width } = useDimensions();
  const [showFilter, setShowFilter] = useState(false);
  const [searchDoctor, setSearchDoctor] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();

  const clinicId = "gangahospitals";
    useEffect(() => {
      
        dispatch(fetch_clientDetails(clinicId == undefined ? "" : clinicId)).then(
          (res) => {
          
          }
        );
      
    }, []);
  return (
    <>
      <Header
        bookingProgress={bookingProgress}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        searchDoctor={searchDoctor}
        setSearchDoctor={setSearchDoctor}
        mrnValidationFailed={mrnValidationFailed}
      />
      <div id="login-layout-body" className={Style.LoginLayout_body}>
        {width >= 992
          ? children
          : React.cloneElement(children, {
              showFilter,
              setShowFilter,
              searchDoctor,
              setSearchDoctor,
            })}

        {location.pathname.search("bookAppointment") == -1 && width >= 992 ? (
          <Footer />
        ) : null}
        {location.pathname.search("bookAppointment") == -1 && width < 992 ? (
          <MobileFooter />
        ) : null}
      </div>
    </>
  );
}

export default LoginLayout;
